import { useContext } from "react";
import { ZephrContext } from "./context";
import { ZephrTracker } from "./ZephrTracker";

export const useTracker = () => useContext(ZephrContext);

export { ZephrTracker };
